import { UseCase } from './types';
import { wayfare } from './wayfare';

export * from './types';
export { wayfare };

// The registry. Order here is the order on the page.
export const useCases: UseCase[] = [wayfare];

// Every credential any use case needs, deduplicated and in the order the page
// offers them. Drives the "2 / 3" progress tracker.
export const credentialsNeededByUseCases = (order: string[]): string[] => {
    const needed = new Set(useCases.flatMap(useCase => useCase.requiredCredentials));
    return order.filter(credentialType => needed.has(credentialType));
};
